/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPlanResponseDto } from '../models/GetPlanResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PlansService {

    /**
     * Fetch the value of a plan
     * @returns GetPlanResponseDto Successfully fetched plan
     * @throws ApiError
     */
    public static getPlanByType({
        type,
    }: {
        type: 'DATA_CATALOG' | 'INTEGRATION' | 'MONITORING' | 'SETTINGS' | 'TENANT',
    }): CancelablePromise<GetPlanResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/plans/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
